import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { PROVET_DIAGNOSTICS_REPOSITORY } from '../domain/repositories/provet-diagnostics.repository';
import { ProvetDiagnosticsRemoteDatasource } from './datasources/remote/provet-diagnostics.remote-datasource';
import { ProvetDiagnosticsMapper } from './mappers/provet-diagnostics.mapper';
import { ProvetDiagnosticsRepositoryImpl } from './repositories/provet-diagnostics.repository.impl';

export function provideProvetRateLimitsData(): EnvironmentProviders {
  return makeEnvironmentProviders([
    ProvetDiagnosticsMapper,
    ProvetDiagnosticsRemoteDatasource,
    { provide: PROVET_DIAGNOSTICS_REPOSITORY, useClass: ProvetDiagnosticsRepositoryImpl },
  ]);
}
